if (!customElements.get('search-filter')) {
  class SearchFilter extends HTMLElement {
    constructor() {
      super();

      // const
      this.URL = location.href; 
      this.MAX_PRICE = 2000000;
      this.SCROLL_TYPE = 'scroll=1';
      this.DEFAULT_UNIT_PRICE_MIN = 1;
      this.DEFAULT_UNIT_PRICE_MAX = 7;

      // element
      this.elSearchItems = this.querySelectorAll('.js-search-item');
      this.elPriceRange = this.querySelector('.js-price-range');
      this.elUnitPriceRange = this.querySelector('.js-unit-price-range');
      this.elUnitPriceSelects = this.querySelectorAll('.js-unit-price-select');
      this.elUnitPriceOptions = this.querySelectorAll('.js-unit-price-option');
      this.elResetBtn = this.querySelector('.js-reset-btn');
      this.elFilterBtn = this.querySelector('.js-filter-btn');
      this.elProductCount = this.querySelector('.js-product-count');


      // member variables
      this.filterUrl = this.URL;
      this.searchEntry = [];
      this.unitPriceGroupMin = 1;
      this.unitPriceGroupMax = 7;
      this.unitPriceSearchKey = this.elUnitPriceRange.dataset.searchKey;


      // 最初の絞り込みURLは、今のURLにscrollパラメータをつけた形にしておく
      const connector = this.URL.indexOf('?') > -1 ? '&' : '?';
      const filterUrl = `${this.URL}${connector}${this.SCROLL_TYPE}`;
      this.elFilterBtn.setAttribute('href', filterUrl);

      if (this.URL.indexOf('?') !== -1) {
        this.URL_PATH = this.URL.split('?')[0];
        this.setInitialParam();
      } else {
        this.URL_PATH = this.URL;
      }

      this.initSearchItem();

      console.log('this.searchEntry', this.searchEntry);

      if (this.elPriceRange) {
        this.initPriceRange();
      }

      if (this.elUnitPriceRange && this.elUnitPriceSelects.length) {
        this.initUnitPriceRange();
      }
    }

    // ページ読み込み時のパラメータをsearchEntryに保持しておく
    setInitialParam () {
      const paramStr = this.URL.split('?')[1];
      const params = paramStr.split('&');
      for (const param of params) {
        const key = decodeURI(param.split('=')[0]);
        // resetやscrollパラメータは引き継がない
        if (key === "reset" || key === "scroll") continue;

        const valueStr = decodeURI(param.split('=')[1]);
        const values = valueStr.split(',');

        for (const valueStr of values) {
          let value = valueStr;
          // unit_price_groupの場合は数値に変換
          if (key === this.unitPriceSearchKey) {
            value = Number(value);
          }

          this.addSearchEntry(key, value);
        }
      }
    }

    initPriceRange () {
      const elRangeInputs = this.querySelectorAll('.js-price-range-input');

      this.rangeMin = this.searchEntry['filter.v.price.gte'] ? Number(this.searchEntry['filter.v.price.gte'][0]) : 0;
      this.rangeMax = this.searchEntry['filter.v.price.lte'] ? Number(this.searchEntry['filter.v.price.lte'][0]) : this.MAX_PRICE;

      const slider = noUiSlider.create(this.elPriceRange, {
        range: {
          'min': 0,
          'max': this.MAX_PRICE
        },
        step: 1,
        start: [this.rangeMin, this.rangeMax],
        connect: true,
        behaviour: 'tap-drag',
      });

      slider.on('update', ( values, handle ) => {
        this.rangeMin = Math.trunc(values[0]);
        this.rangeMax = Math.trunc(values[1]);

        for (const rangeInput of elRangeInputs) {
          rangeInput.value = rangeInput.dataset.rangeType === 'min' ? this.rangeMin : this.rangeMax;
        }
      });

      slider.on('change', values => {
        const minPrice = Number(values[0].replace('.00', ''));
        const maxPrice = Number(values[1].replace('.00', ''));
        this.searchEntry['filter.v.price.gte'] = [Math.floor(minPrice)];
        this.searchEntry['filter.v.price.lte'] = [Math.floor(maxPrice)];

        this.createFilterUrl();
        this.renderContent();
      });

      for (const rangeInput of elRangeInputs) {
        // 初期値設定
        rangeInput.value = rangeInput.dataset.rangeType === "min" ? this.rangeMin : this.rangeMax;

        // inputが変更された際に、sliderの状態を更新するイベントを追加
        rangeInput.addEventListener('change', (e) => {
          const value = Number(e.target.value);
          const rangeType = e.target.dataset.rangeType;
          if (rangeType === 'min') {
            this.rangeMin = value;
          } else {
            this.rangeMax = value;
          }

          slider.set([this.rangeMin, this.rangeMax]);

          this.searchEntry['filter.v.price.gte'] = [this.rangeMin];
          this.searchEntry['filter.v.price.lte'] = [this.rangeMax];

          this.createFilterUrl();
          this.renderContent();
        });
      }
    }

    initUnitPriceRange () {
      // パラメータの値から初期値を取得
      const priceIds = this.searchEntry[this.unitPriceSearchKey];
      if (priceIds) {
        this.unitPriceGroupMin = Math.min(...priceIds);
        this.unitPriceGroupMax = Math.max(...priceIds);
      }

      for (const elSelect of this.elUnitPriceSelects) {
        const priceType = elSelect.dataset.priceType;
        if (priceType === 'min') {
          elSelect.value = this.unitPriceGroupMin;
        } else {
          elSelect.value = this.unitPriceGroupMax;
        }
      }

      // 変更イベント追加
      for (const elSelect of this.elUnitPriceSelects) {
        elSelect.addEventListener('change', (e) => {
          const value = e.target.value;
          const changedPriceType = e.target.dataset.priceType;

          if (changedPriceType === 'min') {
            this.unitPriceGroupMin = Number(value);
          } else {
            this.unitPriceGroupMax = Number(value);
          }

          // 下限値や上限値が、もう片方の値を超えていた場合、変更されていない方の値を初期値にリセットする
          if (changedPriceType === 'min') {
            if (this.unitPriceGroupMin > this.unitPriceGroupMax) {
              this.unitPriceGroupMax = this.DEFAULT_UNIT_PRICE_MAX;
              this.resetUnitOption("max");
            }
          } else {
            if (this.unitPriceGroupMax < this.unitPriceGroupMin) {
              this.unitPriceGroupMin = this.DEFAULT_UNIT_PRICE_MIN;
              this.resetUnitOption("min");
            }
          }

          
          const unitPriceGroupRange = [];
          for (let i = this.unitPriceGroupMin; i <= this.unitPriceGroupMax; i++) {
            unitPriceGroupRange.push(i);
          }

          this.searchEntry[this.unitPriceSearchKey] = unitPriceGroupRange;
          this.createFilterUrl();
          this.renderContent();

          this.updateRangeOption();
        });
      }
    }

    updateRangeOption() {
      const minValue = Math.min(...this.searchEntry[this.unitPriceSearchKey]);
      const maxValue = Math.max(...this.searchEntry[this.unitPriceSearchKey]);

      for (const elOption of this.elUnitPriceOptions) {
        const value = Number(elOption.value);
        const priceType = elOption.dataset.priceType;

        if (priceType === "min") {
          if (value <= maxValue) {
            elOption.classList.remove('hidden');
            elOption.disabled = false;
          } else {
            elOption.classList.add('hidden');
            elOption.disabled = true;
          }
        } else {
          if (value < minValue) {
            elOption.classList.add('hidden');
            elOption.disabled = true;
          } else {
            elOption.classList.remove('hidden');
            elOption.disabled = false;
          }
        }
      }
    }

    resetUnitOption(resetType) {
      const defaultValue = resetType === "min" ? this.DEFAULT_UNIT_PRICE_MIN : this.DEFAULT_UNIT_PRICE_MAX;

      for (const elOption of this.elUnitPriceOptions) {
        if (elOption.dataset.priceType !== resetType) continue;

        elOption.selected = false;
        if (elOption.value === String(defaultValue)) {
          elOption.selected = true;
        }
      }
    }

    initSearchItem() {
      // パラメータに応じて、初期状態を切り替え
      const searchKeys = Object.keys(this.searchEntry);
      for (const key of searchKeys) {
        const elFilter = this.querySelector([`[data-search-item-list="${key}"]`]);
        if (!elFilter) continue;

        const elSearchItems = elFilter.querySelectorAll('.js-search-item');
        for (const elItem of elSearchItems) {
          const value = elItem.dataset.searchValue;
          if (this.searchEntry[key].includes(value)) {
            elItem.checked = true;
          }
        }
      }
      
      // 絞り込みイベント追加
      this.elSearchItems.forEach((target) => {
        target.addEventListener('click', () => {
          const key = target.dataset.searchKey;
          const value = target.dataset.searchValue;
          
          if (target.checked) {
            this.addSearchEntry(key, value);
          } else {
            this.removeSearchEntry(key, value)
          }

          this.createFilterUrl();
          this.renderContent();
        });
      });
    }

    addSearchEntry (key, value) {
      if (this.searchEntry[key]) {
        this.searchEntry[key].push(value);
      } else {
        this.searchEntry[key] = [value];
      }
    }

    removeSearchEntry (key, value) {
      const entryValues = this.searchEntry[key];
      this.searchEntry[key] = entryValues.filter(entryValue => entryValue !== value);
    }

    createFilterUrl () {
      const searchKeys = Object.keys(this.searchEntry);
      if (searchKeys.length === 0) {
        this.filterUrl = this.URL;
        return;
      }

      const filterParam = this.getFilterParam();
      this.filterUrl = this.URL_PATH + filterParam;
    }

    getFilterParam () {
      let params = '';
      for (const key of Object.keys(this.searchEntry)) {
        if (!this.searchEntry[key].length) continue;

        const param = `${key}=${this.searchEntry[key].join(',')}`;
        params += params === '' ? param : `&${param}`;
      }

      params += params === '' ? this.SCROLL_TYPE : `&${this.SCROLL_TYPE}`;

      return `?${params}`;
    }

    async renderContent () {
      this.elFilterBtn.setAttribute('href', this.filterUrl);

      const filteredCount = await this.getFilteredCount();
      this.elProductCount.textContent = filteredCount;
    }

    // 外部からの更新処理
    updateSearchEntry (entry) {
      this.searchEntry[entry.key] = [entry.value];
      console.log(this.searchEntry);
    }

    // 外部からのURLクエリー取得処理
    getSearchQuery () {
      if (!Object.keys(this.searchEntry).length) return "";

      return this.getFilterParam();
    }

    // 個数取得
    async getFilteredCount () {
      let filteredCount = 0;
      await fetch(this.filterUrl)
        .then(response => response.text())
        .then((responseText) => {
          const html = responseText;
          const elHtml = new DOMParser().parseFromString(html, 'text/html');
          const elCount = elHtml.querySelector('.js-product-count').innerText;
          filteredCount = Number(elCount);
        });

      return filteredCount;
    }
  }

  customElements.define('search-filter', SearchFilter);
}

// WebComponentだと、非同期でページが更新させれた際に、再度constructorが実行されてしまうため、一回のみ実行したい処理は以下に定義。
document.addEventListener('DOMContentLoaded', () => {
  const queryParams = new URLSearchParams(window.location.search);

  // resetパラメータがついていた場合はモーダルを展開
  if (queryParams.get('reset')) {
    MicroModal.show('search-filter');
  }

  // scroll_toパラメータがついていた場合は、対象位置までスクロール
  if (queryParams.get('scroll')) {
    const elScrollTarget = document.querySelector('[data-scroll-target]');
    if (elScrollTarget) {
      // ヘッダーの高さは、JSで取得しようとするとCSS読み込みを待つ必要があり遅れるため、ここでは静的に記述する。
      const headerHeight = window.size < 700 ? 60 : 80;
      const elementTop = elScrollTarget.getBoundingClientRect().top;

      window.scrollTo({
        top: elementTop + window.scrollY - headerHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  }
})